module.exports = __webpack_public_path__ + "static/media/sweden.8a861197.svg";